<template>
    <a-spin :spinning="pageloading">
      <a-form class="margin-bottom" :form="form">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
            <!-- <a-form-item label="Termin Release">
              <a-input
                v-decorator="[
                  'termin_release',
                  {
                    rules: [{ required: true }],
                    initialValue: dataInput.termin_release,
                  },
                ]"
                disabled
              ></a-input>
            </a-form-item> -->
            <a-form-item label="Kode / Project Name">
              <a-input
                v-decorator="[
                  'kode_project_name',
                  {
                    rules: [{ required: true }],
                    initialValue: dataInput.kode_project_name,
                  },
                ]"
                disabled
              ></a-input>
            </a-form-item>
            <a-form-item label="Bank Account">
              <a-select
                v-decorator="[
                  'bank_account_id',
                  {
                    rules: [
                      { required: true, message: 'Invoice date Required' },
                    ],
                    initialValue: bank,
                  },
                ]"
                :disabled="bankAccountStatus"
              >
                <a-select-option
                  v-for="item in bankAccount"
                  :key="item.bank_account_id"
                  :value="item.bank_account_id"
                  >[{{ item.bank_account_id }}] {{ item.nama_bank }} ({{
                    item.kode_rekening
                  }})</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Customer Name">
              <a-select
                v-decorator="[
                  'customer_id',
                  {
                    rules: [
                      { required: false, message: 'Customer Name Required' },
                    ],
                    initialValue: dataInput.customer_id,
                  },
                ]"
                showSearch
                option-filter-prop="children" :filter-option="filterOption"
                disabled
              >
                <a-select-option
                  v-for="item in dataInput.customer_list"
                  :key="item.customer_id"
                  :value="item.customer_id"
                  >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-row>
              <a-form-item label="Include PPN">
              <a-radio-group
                  buttonStyle="solid"
                  :disabled="true"
                  v-decorator="['include_ppn',{rules: [{ required: false }], initialValue: dataInput.include_ppn,
                    },
                  ]"
                        ref="site"
                >
                  <a-radio-button value="1" ref="Radio1">Include</a-radio-button>
                  <a-radio-button value="0" ref="Radio2">Exclude</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-row>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
            <a-form-item label="Efaktur No">
              <a-input
                v-decorator="[
                  'efaktur',
                  {
                    rules: [{ required: true, message: 'Efaktur No Required' }],
                  },
                ]"
              ></a-input>
            </a-form-item>

            <a-form-item label="Invoice date">
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="[
                  'invoice_date',
                  {
                    rules: [
                      { required: true, message: 'Invoice date Required' },
                    ],
                    initialValue: dataInput.invoice_date,
                  },
                ]"
              />
            </a-form-item>
            
            <a-form-item label="Upload File Support">
              <a-upload
                :showUploadList="true"
                :fileList="push"
                :beforeUpload="beforeUpload"
                :remove="handleRemove"
                v-decorator="[
                  'upload',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Upload File Support Required',
                      },
                    ],
                    valuePropName: 'push',
                  },
                ]"
              >
                <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";

export default {
  name: "information",
  props: {
    id: String,
    information: {},
    combo_pimpro: {},
  },
  mixins: [CurrencyFormat],
  components: {},
  data() {
    return {
      dataInput: [],
      bank: "",
      bankAccount: [],
      bankAccountStatus: false,
      push: [],
      deliverable: []
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate", "getDefaultDateFormat"]),
  },
  created() {
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.pageloading = true;
      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "account_receivable/create_ar_sales_contract",
        params: {
          tlc: this.getAuth.username,
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      const bank = axios({
        method: "get",
        url: this.$serviceUrl + "bkm/bank",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      return new Promise((resolve, reject) => {
        axios
          .all([
            proses.catch((err) => {
              this.pageloading = false;
              if (!err.response) {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
                this.$router.go(-1);
              } else {
                this.displayMessage("denied-manifest");
                this.$router.push({ name: "beranda" });
              }
              return null;
            }),
            bank.catch((err) => {
              this.pageloading = false;
              if (!err.response) {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
                this.$router.go(-1);
              } else {
                this.displayMessage("denied-manifest");
                this.$router.push({ name: "beranda" });
              }
              return null;
            }),
          ])
          .then((response) => {
            this.dataInput = response[0].data;
            if (!this.dataInput.invoice_date) {
              this.dataInput.invoice_date = null;
            } else {
              this.dataInput.invoice_date = moment(this.dataInput.invoice_date);
            }
            let bankResponse = response[1].data.data;
            if (this.dataInput.bank_account_id === null) {
              this.bankAccountStatus = false;
              this.bankAccount = bankResponse.filter(
                (obj) =>
                  obj.currency &&
                  obj.currency.indexOf(this.dataInput.project_currency) >= 0
              );
            } else {
              this.bankAccountStatus = true;
              this.bankAccount = bankResponse;
            }
            this.bank = this.dataInput.bank_account_id;
            this.deliverable = response[0].data.detail_deliverable;
            this.pageloading = false;
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleRemove() {
      this.push = [];
    },
    save() {
      this.confirmMessage("confirm-save");
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let bnk = _.filter(this.bankAccount, {
          bank_account_id: values.bank_account_id,
        });
        values.currency = bnk[0].currency;

        let cust = _.filter(this.dataInput.customer_list, {
          customer_id : values.customer_id
        });
        values.customer_nm = cust[0] ? cust[0].customer_nm : "";

        Event.$emit("emitChild", {
          values,
          deliverable: this.deliverable,
          termin_dtl: this.dataInput.termin_dtl,
        });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {},
  beforeDestroy() {},
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>